import { render, staticRenderFns } from "./messageCenterSearch.vue?vue&type=template&id=514254d4"
import script from "./messageCenterSearch.vue?vue&type=script&lang=js"
export * from "./messageCenterSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports